import React from "react";
import { Icon } from "semantic-ui-react";

import styles from "./DashboardMetrics.module.scss";

export function DashboardMetrics({ metrics = [], isLoading = false }) {
  return (
    <section className={styles.DashboardMetrics}>
      {(isLoading ? [1, 2, 3, 4] : metrics).map((metric, index) => (
        <article
          key={isLoading ? `placeholder-${index}` : metric.id}
          className={styles.MetricCard}
        >
          {isLoading ? (
            <div className={styles.MetricSkeleton} />
          ) : (
            <>
              <div className={styles.MetricHeader}>
                <p className={styles.MetricTitle}>{metric.title}</p>

                <div
                  className={`${styles.MetricIcon} ${
                    styles[`MetricIcon${metric.type}`]
                  }`}
                >
                  <Icon name={metric.icon} />
                </div>
              </div>

              <p className={styles.MetricValue}>{metric.value}</p>

              <div className={styles.MetricFooter}>
                {metric.trend ? (
                  <>
                    <span
                      className={`${styles.MetricChange} ${
                        styles[
                          `MetricChange${
                            metric.trend.direction === "up"
                              ? "success"
                              : "danger"
                          }`
                        ]
                      }`}
                    >
                      <Icon
                        name={
                          metric.trend.direction === "up"
                            ? "arrow up"
                            : "arrow down"
                        }
                      />
                      {metric.trend.label}
                    </span>

                    <span className={styles.MetricDescription}>
                      {metric.trend.comparisonLabel}
                    </span>
                  </>
                ) : (
                  <span className={styles.MetricDescription}>
                    {metric.description}
                  </span>
                )}
              </div>
            </>
          )}
        </article>
      ))}
    </section>
  );
}
